import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import '../remark-element';
import './app-navigator';
import '../logo';
import '../form/button';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: '@gsmlg/app-navigator',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  appName: string;
  fixed: boolean;
  controlParent: boolean;
  color: string;
  backgroundColor: string;
}

// prettier-ignore
const Template: Story<ElementProps> = ({
  appName,
  fixed,
  color,
  backgroundColor,
  controlParent,
}) =>
  html`
  <app-navigator
    app-name=${appName}
    ?fixed=${fixed}
    ?control-parent=${controlParent}
    color=${color}
    background-color=${backgroundColor}
  >
  <logo-gsmlg-dev slot="logo"></logo-gsmlg-dev>
  <app-navigator-menu
    slot="menus"
  >
    <wc-button mode="link">Go To Github</wc-button>

    <wc-button href="https://github.com/Youtube" target="_blank" slot="submenu">Youtube</wc-button>
    <wc-button href="https://github.com/Twitter" target="_blank" slot="submenu">Twitter</wc-button>
    <wc-button href="https://github.com/Facebook" target="_blank" slot="submenu">Facebook</wc-button>
    <wc-button href="https://github.com/Instagram" target="_blank" slot="submenu">Instagram</wc-button>
  </app-navigator-menu>
  </app-navigator>
  
  <remark-element>
    ## app-navigator element

    Render AppNavigator for application.

    \`\`\`html
    ${`<app-navigator
      app-name=${appName}
      ?fixed=${fixed}
      ?hidename=${controlParent}
      color=${color}
      background-color=${backgroundColor}
    >
      <logo-gsmlg-dev slot="logo"></logo-gsmlg-dev>
      <wc-button slot="nav" mode="primary">Console</wc-button>
      <wc-button slot="nav" mode="link">Dashboard</wc-button>
      <div slot="user">Josh</div>
      <div slot="actions">M</div>
    </app-navigator>`}
    \`\`\`

    ### CSS Variables

    \`\`\`css
    var(--app-navigator-background-color, #fc125c);
    var(--app-navigator-color, #fff);
    var(--app-navigator-height, 3.5rem);
    var(--app-navigator-menu-background-color, inherit);
    var(--app-navigator-menu-color, inherit);
    var(--app-navigator-menu-item-background-color, inherit);
    var(--app-navigator-menu-item-color, inherit);
    var(--app-navigator-name-color, inherit);
    \`\`\`

    ### attributes:

    - \`app-name\`

    show when screen width > 992px

    \`GSMLG-DEV\` is app-name in demo

    - \`fixed\`

    set app-navigator to \`postion: fixed\`, need to add a padding-top to page

    - \`hidename\`

    force hide app-name

    - \`color\`

    text color

    - \`background-color\`

    background color

    ### slots:

    - \`logo\`

    Where logo is placed.

    - \`nav\`

    Add nav menus.

    - \`actions\`

    Add user actions, right part, user slot's left.

    - \`user\`

    Add user Icon or menu, at right part.

  </remark-element>
  
  `;

export const Basic = Template.bind({});
// More on args: https://storybook.js.org/docs/web-components/writing-stories/args
Basic.args = {
  appName: 'GSMLG-DEV',
  fixed: false,
  controlParent: false,
  color: '#362424',
  backgroundColor: 'transparent',
};
